/* unplugin-vue-components disabled */import { render } from "./ReferenceInfo2.vue?vue&type=template&id=412cba62&scoped=true&ts=true"
import script from "./ReferenceInfo2.vue?vue&type=script&lang=ts"
export * from "./ReferenceInfo2.vue?vue&type=script&lang=ts"

import "./ReferenceInfo2.vue?vue&type=style&index=0&id=412cba62&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/yunxiaobao-test/test-huodada-com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-412cba62"]])

export default __exports__